import React from "react";
import style from "./index.module.scss";
import { Dropdown, Icon, Menu, Modal } from "antd";
import useStorage from "utils/useStorage";
import classNames from "classnames";
import Config from "config";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import Storage from "utils/Storage";

export default function BatchPicker() {
    const batchList = useAtomValue(termListAtom);
    const [batch, setBatch] = useStorage(
        "batch",
        Storage.get("batch") || Config.DefaultBatch
    );

    const handleChangeBatch = (batch: string) => {
        Modal.confirm({
            title: "提示：",
            content:
                "切换学期后，系统中的课程、作业、考试、答疑等均为所选学期下的内容。",
            onOk: () => setBatch(batch)
        });
    };

    const menu = (
        <Menu className={style.menu}>
            {batchList?.map(item => (
                <Menu.Item
                    key={item.batchNo}
                    onClick={() => handleChangeBatch(item.batchNo)}
                    className={classNames(style.menuItem, {
                        [style.selected]: item.batchNo === batch
                    })}>
                    {item.batchName}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className={style.root}>
            <Dropdown overlay={menu} className={style.dropdown}>
                <div>
                    {batchList?.find(item => item.batchNo === batch)?.batchName}{" "}
                    <Icon type="down" />
                </div>
            </Dropdown>
        </div>
    );
}
